import { z } from 'zod'

export const Neo4jConfigSchema = z.object({
  uri: z.string().min(1),
  user: z.string().min(1),
  password: z.string().min(1)
})

export type Neo4jConfig = z.infer<typeof Neo4jConfigSchema>

export const DatabaseDialect = z.enum(['MYSQL', 'MSSQL', 'POSTGRESQL'])
export type DatabaseDialect = z.infer<typeof DatabaseDialect>

export const DatabaseConnectionConfigSchema = z.object({
  name: z.string().min(1),
  databaseType: DatabaseDialect,
  host: z.string().min(1),
  port: z.number().int().positive(),
  username: z.string().min(1),
  password: z.string().min(1),
  database: z.string().min(1),
  enabled: z.boolean().default(true)
})

export type DatabaseConnectionConfig = z.infer<typeof DatabaseConnectionConfigSchema>

export const ApiKeysConfigSchema = z.object({
  anthropicApiKey: z.string().optional(),
  openaiApiKey: z.string().optional()
})

export type ApiKeysConfig = z.infer<typeof ApiKeysConfigSchema>

export const OntologyConfigSchema = z.object({
  neo4j: Neo4jConfigSchema,
  apiKeys: ApiKeysConfigSchema,
  dbConnections: z.array(DatabaseConnectionConfigSchema).default([])
})

export type OntologyConfig = z.infer<typeof OntologyConfigSchema>

export interface SafeOntologyConfig {
  neo4j: { uri: string; user: string }
  apiKeys: { anthropicApiKey: boolean; openaiApiKey: boolean }
  dbConnections: Array<{
    name: string
    databaseType: DatabaseDialect
    host: string
    port: number
    database: string
    enabled: boolean
  }>
}
